import React from "react";

import "./AvailableFunds.scss";
import InfoBubble from "Components/InfoBubble";

const AvailableFundsBase = ({availableFunds, limitAmount, headerText, tooltipText}) => {

  const formattedAvailableFunds = availableFunds?.toLocaleString();
  const dollars = formattedAvailableFunds?.split('.')[0];
  const cents = formattedAvailableFunds?.split('.')[1];

  const tooltip = <InfoBubble message={tooltipText} title="Available Funds Tooltip" />
  const limitDiv = <div className="limit">${limitAmount || "0"} LIMIT</div>

  return (
    <div className="available-funds">
      {headerText && <div>{headerText} {tooltipText && tooltip}</div>}
      <div className="amount">
        <span className="dollar-sign-cents">$</span>
        <span className="dollar">{dollars || 0}</span>
        <span className="dollar-sign-cents">{cents ? cents.padEnd(2, "0") : "00"}</span>
      </div>
      {limitAmount && limitDiv}
    </div>
  );
};

export default AvailableFundsBase;